// Chinese Traditional
export const zh_TW = {
    weeklyRewards: '每週獎勵還剩',
    days: '天',
    hours: '小時',
    minutes: '分鐘',
    seconds: '秒',
    authenticating: '認證中',
    verifyWallet: '請等待我們驗證您的錢包',
    authRequired: '需要認證',
    authFailed: '認證失敗，請重試。',
    points: '積分',
    rank: '排名',
    of: '/',
    players: '玩家',
    weeklyTopPlayers: '本週頂尖玩家',
    thisWeekLeaderboard: '本週排行榜',
    rankingsReset: '排名將在每週日UTC午夜重置',
    yourPoints: '您的積分',
    dailyRewardAvailable: '每日獎勵可領取！',
    nextClaimAvailable: '下次可領取時間：',
    claimDailyReward: '領取每日獎勵',
    claiming: '領取中...',
    multiplier: '倍數',
    bonusPointsMultiplier: '獎勵積分倍數',
    outOf: '/',
    loading: '載入中...',
    errorLoading: '載入錯誤',
    noEntries: '暫無記錄',
    leaderboard: '排行榜',
    tasks: '任務',
    rules: '規則',
    profile: '個人資料',
    comingSoon: '即將推出...',
    completedTasks: '已完成任務',
    dailyRewardsClaimed: '已領取每日獎勵',
    times: '次',
    recentActivity: '最近活動',
    noRewardsClaimed: '尚未領取任何獎勵',
    dailyReward: '每日獎勵',
    howItWorks: '如何運作',
    welcomeMessage: '歡迎來到Coinomi獎勵！完成各種任務賺取積分，攀登排行榜。',
    dailyRewardsTitle: '每日獎勵',
    dailyRewardsRules: [
        '每24小時領取一次每日獎勵',
        '每次領取可獲得100積分',
        '積分將根據您的倍數倍增',
    ],
    multiplierBonusesTitle: '倍數獎勵',
    multiplierBonusesRules: [
        '從1倍開始',
        '連接Telegram獲得+10%獎勵',
        '驗證郵箱獲得+10%獎勵',
        '獎勵可疊加以獲得最大收益',
    ],
    leaderboardTitle: '排行榜',
    leaderboardRules: ['與其他玩家競爭', '即時更新排名', '頂尖玩家獲得特殊獎勵'],
    boostEarningsTitle: '提升收益',
    boostEarningsRules: ['完成挑戰獲得獎勵', '加入我們的Telegram社群', '保持活躍以最大化您的獎勵'],
    challenges: '挑戰',
    telegramChallenge: 'Telegram挑戰',
    emailChallenge: '郵箱挑戰',
    connectTelegram: '連接Telegram',
    shareEmail: '分享郵箱',
    telegramSuccess: '🎉 恭喜！您現在獲得所有獎勵的永久10%加成！',
    telegramPrompt: '連接您的Telegram帳號獲得所有獎勵的永久10%加成！',
    emailSuccess: '🎉 恭喜！您現在獲得所有獎勵的永久10%加成！',
    emailPrompt: '分享您的郵箱獲得所有獎勵的永久10%加成！',
    connectEmail: '連接郵箱',
    cancel: '取消',
    emailPrivacy: '我們只會使用您的郵箱發送重要更新和獎勵通知。',
    connectYourEmail: '連接您的郵箱',
    emailBonus: '🎉 連接郵箱獲得所有獎勵的永久10%加成！',
    enterValidEmail: '請輸入有效的郵箱地址',
    emailAddress: '郵箱地址',
    errorSavingEmail: '儲存郵箱時出錯。請重試。',
    claimButton: '領取',
    earnedReward: '獲得獎勵',
    rewardValue: '{{amount}}積分',
    claimingReward: '領取中...',
    claimSuccess: '成功領取{{amount}}積分！',
    claimError: '領取獎勵失敗。請重試。',
    privacyDisclaimer: 'Coinomi不收集個人資料；第三方系統安全管理積分和社交連接。',
    streakBonus: '連續獎勵',
    streakDays: '{{days}}/5天',
    streakBonusValue: '+{{percent}}%',
    streakMaxBonus: '+10%額外',
    streakDescription: '連續5天領取獲得最大獎勵',
    streakToday: '今天',
    streakMissed: '錯過',
    streakComplete: '完成',
    streakActive: '連續中',
    streakLost: '連續中斷',
    streakNext: '下一個',
    home: '首頁',
    currentStreak: '當前連續',
    totalClaims: '總領取次數',
    userStats: '您的統計',
    referrals: '推薦',
    referralProgram: '推薦計劃',
    howReferralWorks: '推薦如何運作：',
    referralSteps: [
        '與朋友分享您的推薦連結',
        '當他們使用您的連結加入時，他們成為您的推薦',
        '每個活躍推薦都能獲得獎勵積分',
        '在這裡追蹤您的推薦和收益',
    ],
    referralRewards: '推薦積分獎勵：',
    referralBonuses: ['推薦一人獲得100積分', '獲得被推薦人10%的積分獎勵'],
    yourReferralLink: '您的推薦連結',
    copyToClipboard: '複製到剪貼簿',
    linkCopied: '連結已複製到剪貼簿！',
    totalReferrals: '總推薦數',
    yourReferralCode: '您的推薦碼',
    referralCodeCopied: '推薦碼已複製！',
    editReferralCode: '編輯推薦碼',
    editReferralCodeInstructions: '選擇新的推薦碼。必須至少5個字符，可包含字母和數字。',
    newReferralCode: '新推薦碼',
    referralCodeRequirements: '最少5個字符，僅限字母和數字',
    updating: '更新中...',
    update: '更新',
    referralCodeTaken: '此推薦碼已被使用',
    haveReferralCode: '有推薦碼？',
    enterReferralCodePrompt: '如果有人推薦您，在此輸入他們的推薦碼以連接帳戶。',
    enterReferralCode: '輸入推薦碼',
    enterReferralCodeInstructions: '輸入分享給您的推薦碼。',
    referralCode: '推薦碼',
    referralCodeFormat: '僅限字母和數字',
    submitting: '提交中...',
    submit: '提交',
    enterCode: '輸入代碼',
    pleaseAddtoken: '請在URL中添加token參數',
    authenticationError: '認證過程中發生錯誤',
    noUserFound: '未找到用戶',
    userNotFoundMessage: '無法找到用戶資料',
    backToHome: '返回首頁',
    retry: '重試',
    baseMultiplier: '基礎倍數',
    telegramBonus: 'Telegram獎勵',
    referralChallenge: '推薦挑戰',
    referralChallengePrompt: '邀請朋友賺取獎勵積分！每推薦一人獲得100積分，外加他們收益的10%！',
    startReferring: '開始推薦',
    referralSuccess: '🎉 恭喜！您已成功推薦用戶並正在賺取獎勵積分！',
    unranked: '未排名',
    noPlayersYet: '成為第一個加入的玩家！',
    shareVia: '分享方式',
    shareOn: '分享到{{network}}',
    shareInviteText:
        '🚀 我正在用@CoinomiWallet賺取免費加密貨幣！\n\n在coinomi.com/downloads下載Coinomi，在應用中加入#Coinomi Rewards時輸入我的推薦碼{{referralCode}}即可獲得獎勵。',
    // Twitter Challenge
    twitterChallenge: 'Twitter挑戰',
    connectTwitter: '連接Twitter',
    twitterSuccess: '🎉 恭喜！您現在獲得所有獎勵的10%永久加成！',
    twitterPrompt: '關聯您的Twitter帳號，獲得所有獎勵的10%永久加成！',
    pleaseAddUserId: '請在URL中添加userId參數',
    emailChallengePrompt: '分享您的郵箱獲得所有獎勵的永久10%加成！',
    emailChallengeSuccess: '🎉 已連接！您現在獲得所有獎勵的永久10%加成！',
    followKoalaWalletChallenge: '請在Twitter上關注@coinomiWallet支持我們！',
    twitterAuthSuccessTitle: 'Twitter已成功連接！',
    twitterAuthSuccessMessage: 'Twitter帳號已成功連接。您現在可以繼續使用應用。',
    continueToApp: '繼續進入應用',
    twitter_like: '已按讚推文',
    twitter_retweet: '已轉發推文',
    disconnect: '斷開連接',
    followCoinomiWallet: '在Twitter上關注@coinomiWallet支持我們！',
    connectedBonus: '🎉 已連接！您現在獲得所有獎勵的永久10%加成！',
};
